export default __webpack_public_path__ + "static/media/icon-punch.1d835a48.svg";